import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = 'light' | 'dark'

interface ThemeState {
    theme : Theme,
    setTheme : (theme:Theme) => void
    toggleTheme: () => void
}

export const useThemeStore = create<ThemeState>()(
    persist(
        (set)=>({
            theme:'light',

            setTheme: (theme) => {
                set({theme})
            },

            toggleTheme: () => {
                set((state) => ({
                    theme : state.theme === 'light' ? 'dark' : 'light',
                }))
            },
        }),
        {
            name : 'tpm-theme'
        },
    ),
)
